import { resolveIdentifier, types } from 'mobx-state-tree';
import { Duty } from './Duty';

// Lightweight model for DutyAssignment as embedded in DutyExchangeItem.
// Uses types.number (not identifierNumber) to avoid MST identifier collisions
// with DutyAssignmentStore, which stores the authoritative DutyAssignment nodes.
// exportedOn is carried directly (returned by the dutyExchangeItem API) rather
// than resolved from DutyAssignmentStore, which is not populated in the history flow.
export const DutyAssignmentForExchangeItem = types
  .model('DutyAssignmentForExchangeItem', {
    dutyAssignmentId: types.number,
    dutyId: types.number,
    pharmacyId: types.maybe(types.number),
    exportedOn: types.maybeNull(types.string),
  })
  .views((self) => ({
    get duty() {
      return resolveIdentifier(Duty, self, self.dutyId);
    },
  }));
